// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1QIsM","search":"Settings_search__2lEEy","filter":"Settings_filter__1clHu"};